export default __webpack_public_path__ + "static/media/new.767927a1.png";